import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";

@Component({
	selector: "app-header-title-with-button",
	templateUrl: "./header-title-with-button.component.html"
})
export class HeaderTitleWithButtonComponent implements OnInit {
	actions: string[];
	@Input() title: string;
	@Input() subtitle: string;
	@Input() nameButtom: string;
	@Input() action: string;
	@Input() page: string;
	@Output() eventButton = new EventEmitter<any>(true);

	constructor(private router: Router) {}

	ngOnInit() {
		this.actions = localStorage.getItem("profileClaim").split(",");
	}

	goToPage() {
		this.router.navigate([this.page]);
	}

	actionButton(fileInputEvent: any): void {
		this.eventButton.emit(fileInputEvent.target.files[0]);
	}

	actionButtonModal(): void {
		this.eventButton.emit();
	}
}
